import StaffLogin from "@/components/StaffLogin";
export default function SuperAdminLogin() {
  return <StaffLogin role="superadmin" title="SuperAdmin Login" subtitle="Sign in with your credentials & access code." />;
}
